import type { OnboardingRequirement, OnboardingSessionConfig } from '@onefootprint/request-types';

// Environment detection
const IS_STORYBOOK = typeof window !== 'undefined' && '__STORYBOOK_PREVIEW__' in window;
const IS_VITEST = typeof window !== 'undefined' && '__vitest_browser__' in window;

const IS_TEST_ENV = IS_STORYBOOK || IS_VITEST;

// Migrated: ready for production
const MIGRATED_KINDS: OnboardingRequirement['kind'][] = [
  'collect_card_data',
  'collect_custom_data',
  'select_conditional_branch',
  'collect_investor_profile',
  'collect_data',
  'collect_business_data',
  'create_business_onboarding',
  'register_auth_method',
];

// Orgs enabled for collect_document v2 (limited rollout)
const COLLECT_DOCUMENT_V2_ORG_IDS = new Set([
  'org_hyZP3ksCvsT0AlLqMZsgrI',
  'org_EA6MoHnwQDQqNdriEjgWon',
  'org_wrMg7lhSpZif14SIhC9ihL',
]);

// In progress: dev/test only (without feature flags)
const IN_PROGRESS_KINDS: OnboardingRequirement['kind'][] = ['liveness'];

type ShouldRedirectParams = Required<Pick<OnboardingSessionConfig, 'orgId' | 'flags'>> & {
  kind: OnboardingRequirement['kind'];
};

export const shouldRedirectToV2 = ({ kind, flags, orgId }: ShouldRedirectParams): boolean => {
  // Always redirect for fully migrated kinds
  if (MIGRATED_KINDS.includes(kind)) {
    return true;
  }

  if (kind === 'collect_document') {
    return COLLECT_DOCUMENT_V2_ORG_IDS.has(orgId);
  }

  if (kind === 'liveness' && flags?.useLivenessV2) {
    return true;
  }

  // Fallback to test environment check for in-progress kinds
  if (IN_PROGRESS_KINDS.includes(kind)) {
    return IS_TEST_ENV;
  }

  return false;
};
